import { OrderStatus, OrderStatusIcon, OrderStatusTitle } from "./OrderStatus"

export const SnackbarStatus = {
    ...OrderStatus,
    newOffer: 'New Offer',
}

export const SnackBarTitle = {
    ...OrderStatusTitle,
    [SnackbarStatus.confirmed]: 'Your order will dispatch soon',
    [SnackbarStatus.unfulfilled]: 'Your order will dispatch soon',
    [SnackbarStatus.intransit]: 'Your order is on the way',
    [SnackbarStatus.completed]: 'Rate your order experience',
    [SnackbarStatus.newOffer]: 'New Offer Update',
}

export const SnackBarIcon = {
    ...OrderStatusIcon,
    [SnackbarStatus.completed]: '/images/icons/orderStatus/rate.svg',
    [SnackbarStatus.newOffer]: '/images/icons/orderStatus/newOffer.svg',
}

export const SnackBarDescription = {
    [SnackbarStatus.inProgress]: '',
    [SnackbarStatus.received]: '',
    [SnackbarStatus.confirmed]: '',
    [SnackbarStatus.intransit]: '',
    [SnackbarStatus.completed]: '',
    [SnackbarStatus.cancelled]: '',
    [SnackbarStatus.unfulfilled]: '',
    [SnackbarStatus.unacknowledged]: '',
    [SnackbarStatus.completed]: 'Tell us about your experience',
    [SnackbarStatus.newOffer]: 'See new offers available on my store'
}
